<template>
  <div id="Product" v-if="product !== null">
    <Header />

    <ShowRouter :prod="product" />
    <section v-if="isMobile()">
      <v-container fluid>
        <v-layout wrap>
          <v-flex xs2 class="primary">
            <div class="container-arrow">
              <img
                src="../assets/LeftArrow.svg"
                class="slider-arrow"
                @click="setImg(false)"
                v-if="showPrevArrow"
              />
            </div>
          </v-flex>
          <v-flex xs8 class="primary">
            <img :src="selectedImg.url" width="100%" height="100%" />
          </v-flex>
          <v-flex xs2 class="primary">
            <div class="container-arrow">
              <img
                src="../assets/RightArrow.svg"
                class="slider-arrow"
                @click="setImg(true)"
                v-if="showNextArrow"
              />
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <h1 class="product-name" @click="toEditProd()">
        {{ product.name }}
      </h1>
      <h5 class="description">
        {{ product.description }}
      </h5>

      <v-container class="container">
        <v-layout wrap>
          <v-flex xs9 class="primary">
            <div>
              <b-form-group
                class="itemForm"
                label="Diseños:"
                label-for="input-1"
              >
                <b-form-select
                  id="input-1"
                  v-model="selectedOptionName"
                  @change="setOption()"
                  :options="getOptionsName()"
                  required
                ></b-form-select>
              </b-form-group>
            </div>
          </v-flex>
          <v-flex xs3 class="primary">
            <h5 class="price-container">$ {{ selectedOption.price }}</h5>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="stock-container">
        <div v-if="selectedOption.stock > 0">
          <p>Producto disponible!</p>
          <p class="information-text">
            En caso de querer un diseño personalizado contáctenos y le
            informamos si es posible realizarlo.
          </p>
        </div>
        <p v-else>
          Momentaneamente sin stock, consulte para conocer el tiempo de entrega!
        </p>
      </div>
      <div class="bandAid" v-if="getAuth">
        <BandAid
          :quantity="getQuantityByShippingCart"
          @plusQuantity="innerPlusQuantity()"
          @lessQuantity="innerLessQuantity()"
        />
      </div>
    </section>
    <section v-else>
      <v-container class="container">
        <v-layout wrap>
          <v-flex xs1 class="primary">
            <div class="container-arrow">
              <img
                src="../assets/LeftArrow.svg"
                class="slider-arrow"
                @click="setImg(false)"
                v-if="showPrevArrow"
              />
            </div>
          </v-flex>
          <v-flex xs5 class="primary">
            <img :src="selectedImg.url" width="100%" height="100%" />
          </v-flex>
          <v-flex xs1 class="primary">
            <div class="container-arrow">
              <img
                src="../assets/RightArrow.svg"
                class="slider-arrow"
                @click="setImg(true)"
                v-if="showNextArrow"
              />
            </div>
          </v-flex>
          <v-flex xs5 class="primary">
            <h1 class="product-name" @click="toEditProd()">
              {{ product.name }}
            </h1>
            <h5>
              {{ product.description }}
            </h5>

            <v-container class="container">
              <v-layout wrap>
                <v-flex xs9 class="primary">
                  <div>
                    <b-form-group
                      class="itemForm"
                      label="Diseños:"
                      label-for="input-1"
                    >
                      <b-form-select
                        id="input-1"
                        v-model="selectedOptionName"
                        @change="setOption()"
                        :options="getOptionsName()"
                        required
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </v-flex>
                <v-flex xs3 class="primary">
                  <h5 class="price-container">$ {{ selectedOption.price }}</h5>
                </v-flex>
              </v-layout>
            </v-container>

            <div class="stock-container">
              <div v-if="selectedOption.stock > 0">
                <p>Producto disponible!</p>
                <p class="information-text">
                  En caso de querer un diseño personalizado contáctenos y le
                  informamos si es posible realizarlo.
                </p>
              </div>
              <p v-else>
                Momentaneamente sin stock, consulte para conocer el tiempo de
                entrega!
              </p>
            </div>

            <div v-if="getAuth">
              <BandAid
                class="bandAid"
                :quantity="getQuantityByShippingCart"
                @plusQuantity="innerPlusQuantity()"
                @lessQuantity="innerLessQuantity()"
              />
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section>
      <TitleComponent
        v-if="relatedProducts.length > 0"
        text="Productos Relacionados"
      />

      <ProductMasonry
        :products="relatedProducts"
        :isReloadPageForRelatedProducts="true"
      />
    </section>

    <WppComponent />
    <Footer />
  </div>
</template>

<script>
import { db } from "../firebase";
import firebase from "firebase/firebase";
import mobile_detection from "../mixins/mobile_detection";
import user_detection from "../mixins/user_detection";
import WppComponent from "../components/WppComponent";
import ShowRouter from "../components/ShowRouter";
import TitleComponent from "../components/TitleComponent";
import ProductMasonry from "../components/ProductMasonry";
import BandAid from "../components/BandAid";
import Footer from "../components/Footer";
import Header from "../components/Header.vue";

export default {
  mixins: [mobile_detection, user_detection],
  name: "Product",
  firebase: {},
  data() {
    return {
      product: null,
      relatedProducts: [],
      selectedOptionName: "",
      selectedOption: null,
      selectedImg: {
        url: "",
        index: -1,
      },
      prodKey: -1,
    };
  },
  mounted() {
    this.getProducts();
    this.isUserAdmin();
  },
  computed: {
    showNextArrow() {
      if (this.selectedOption !== null) {
        let maxIndex = this.selectedOption.images.length - 1;

        if (maxIndex > this.selectedImg.index) {
          return true;
        }
      }
      return false;
    },
    showPrevArrow() {
      if (this.selectedImg.index > 0) {
        return true;
      }
      return false;
    },
    getQuantityByShippingCart() {
      let quantity = 0;
      let prods = this.$store.getters.getSelectedProducts;

      let p = prods.filter((t) => t.name === this.product.name);

      if (p.length > 0) {
        let op = p[0].options.filter(
          (t) => t.name === this.selectedOption.name
        );

        if (op.length > 0) {
          quantity = op[0].quantity;
        }
      }

      return quantity;
    },
  },
  methods: {
    innerPlusQuantity() {
      let prods = this.$store.getters.getSelectedProducts;

      let p = prods.filter((t) => t.name === this.product.name);

      if (p.length === 0) {
        prods.push({
          code: this.product.code,
          name: this.product.name,
          options: [
            {
              name: this.selectedOption.name,
              unitPrice: this.selectedOption.price,
              quantity: 1,
              image: this.selectedOption.images[0].url,
            },
          ],
        });
      } else {
        let indexProd = prods.indexOf(p[0]);

        let op = p[0].options.filter(
          (t) => t.name === this.selectedOption.name
        );

        if (op.length === 0) {
          prods[indexProd].options.push({
            name: this.selectedOption.name,
            unitPrice: this.selectedOption.price,
            quantity: 1,
            image: this.selectedOption.images[0].url,
          });
        } else {
          let indexOption = p[0].options.indexOf(op[0]);

          prods[indexProd].options[indexOption].quantity++;
        }
      }

      this.$store.commit("SET_SELECTED_PRODUCTS", prods);
      this.$store.commit("SET_SHOW_SHOPPING_CART_MODAL", true);
    },
    innerLessQuantity() {
      let prods = this.$store.getters.getSelectedProducts;

      let p = prods.filter((t) => t.name === this.product.name);

      if (p.length > 0) {
        let indexProd = prods.indexOf(p[0]);

        let op = p[0].options.filter(
          (t) => t.name === this.selectedOption.name
        );

        if (op.length > 0) {
          let indexOption = p[0].options.indexOf(op[0]);

          prods[indexProd].options[indexOption].quantity--;

          if (prods[indexProd].options[indexOption].quantity === 0) {
            prods[indexProd].options.splice(indexOption, 1);
            if (prods[indexProd].options.length === 0) {
              prods.splice(indexProd, 1);
            }
          }
        }
      }

      this.$store.commit("SET_SELECTED_PRODUCTS", prods);
    },
    toEditProd() {
      if (this.getAuth) {
        this.$router.replace(`news?k=${this.prodKey}`);
      }
    },
    getProducts() {
      let code = this.$route.query.c;

      const t = this;
      db.ref("products")
        .once("value")
        .then(function (snapshot) {
          var list = snapshot.val();
          let prods = Object.entries(list);
          prods.forEach((prod) => {
            if (prod[1].code == code) {
              t.prodKey = prod[0];
              t.product = prod[1];
            }
          });
          prods.forEach((prod) => {
            if (
              t.product.category == prod[1].category &&
              t.product.code !== prod[1].code
            ) {
              t.relatedProducts.push(prod[1]);
            }
          });
        });
    },
    getOptionsName() {
      let array = [];

      this.product.options.forEach((element) => {
        if (array.length === 0 && this.selectedOptionName === "") {
          this.selectedOptionName = element.name;
          this.selectedOption = element;
          this.selectedImg.url = element.images[0].url;
          this.selectedImg.index = 0;
        }
        array.push(element.name);
      });

      return array;
    },
    setOption() {
      this.product.options.forEach((element) => {
        if (element.name === this.selectedOptionName) {
          this.selectedOption = element;
          this.selectedImg.url = element.images[0].url;
          this.selectedImg.index = 0;
        }
      });
    },
    setImg(next) {
      let index = this.selectedImg.index;

      if (next) {
        index++;
      } else {
        index--;
      }

      this.selectedImg.url = this.selectedOption.images[index].url;
      this.selectedImg.index = index;
    },
  },
  components: {
    WppComponent,
    ShowRouter,
    TitleComponent,
    ProductMasonry,
    BandAid,
    Footer,
    Header,
  },
};
</script>

<style scoped>
.bandAid {
  text-align: -webkit-center;
}
.shopping-options-container {
  margin: 25px 0px 0px 0px;
}
.container {
  margin-top: 2vh;
}
.product-name {
  float: left;
  width: 100%;
  margin: 0 0 35px 0;
  font-size: 30px;
  font-family: inherit;
}
.related-prods {
  justify-content: center;
}
.itemForm {
  margin: 10px 0px 10px 0px;
  width: max-content;
}
.information-text {
  font-size: 13px;
}
.price-container {
  margin-top: 48px;
  text-align: end;
}
.stock-container {
  margin-top: 20px;
}
svg:not(:root) {
  overflow: hidden;
}
.slider-arrow {
  fill: #5f6a79;
}
.slider-arrow {
  width: 60px;
  height: 100%;
}
.container-galery {
  display: inline-flex;
}
.container-arrow {
  height: 100%;
}
.white {
  background: white;
  color: white;
  width: 60px;
}
.item {
  height: max-content;
}

.itemForm,
p,
.p,
h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Open Sans";
  letter-spacing: 2px;
  color: #808080;
}

@media only screen and (max-width: 600px) {
  .product-name {
    margin: 20px 0px 35px 0px;
    padding: 5px;
    text-align: center;
    font-size: 20px;
  }
  .description {
    margin: 0px 12px 0px 12px;
    font-size: 15px;
  }
  .container {
    margin-top: 0 !important;
  }
  .stock-container {
    margin: 0px 12px 0px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue